export const DEFAULT_AUDIO_BITRATE = "192k";
export const DEFAULT_VIDEO_BITRATE = "2.5M";
export const DEFAULT_VIDEO_ENCODER = "VP9";
export const DEFAULT_LOCATION = "Web";
export const DEFAULT_MIRRORING = false;
export const DEFAULT_SELFIE = true;
export const DEFAULT_FRAME_RATE = 30;
